import { OrbitProgress } from "react-loading-indicators";

export default function Loading() {
  return (
    <div className="flex items-center justify-center h-screen bg-black bg-opacity-85 z-50 absolute top-0 left-0 right-0 bottom-0">
      <OrbitProgress
        dense
        color="rgb(23, 111, 166)"
        size="medium"
        text=""
        textColor=""
      />
    </div>
  );
}
